import React from "react";
import InfoSection from "@components/pages/info/info_section";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";
import { Col, Row } from "@components/ui";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Upplýsinganúmerið - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection title="Upplýsinganúmerið 1819" titleSize={4}>
                <p className="mb-1">
                    1819 svarar almennum upplýsingum, t.d. upplýsingum um símanúmer, heimilisföng,
                    opnunartíma fyrirtækja ásamt leiðarvísun
                </p>
            </InfoSection>
            <InfoSection title="Almennur afgreiðslutími" titleSize={4}>
                <Row className="d-flex mb-1">
                    <Col md={6} className="" style={{ textAlign: "center" }}>
                        <p className="m-0">Virka daga</p>
                        <p style={{ fontSize: 25, margin: 0 }}>08:00 - 21:00</p>
                    </Col>
                    <Col md={6} className="justify-content-center" style={{ textAlign: "center" }}>
                        <p className="m-0">Helgar</p>
                        <p style={{ fontSize: 25, margin: 0 }}>09:00 - 21:00</p>
                    </Col>
                </Row>
            </InfoSection>
            <InfoSection title="Opnunartímar yfir páskana" titleSize={4}>
                <table style={{ width: "100%" }} className="table mb-2">
                    <tbody>
                        <tr>
                            <td style={{ width: 250 }}>Skírdagur, 17. apríl</td>
                            <td>09:00 - 17:00</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Föstudagurinn langi, 18. apríl</td>
                            <td>Lokað</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Laugardagur, 19. apríl</td>
                            <td>09:00 - 21:00</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Páskadagur, 20. apríl</td>
                            <td>Lokað</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Annar í páskum, 21. apríl</td>
                            <td>09:00 - 17:00</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Sumardagurinn fyrsti, 24. apríl</td>
                            <td>09:00 - 17:00</td>
                        </tr>
                    </tbody>
                </table>
            </InfoSection>
            {/* <InfoSection title="Opnunartímar yfir hátíðirnar" titleSize={4}>
                <table style={{ width: "100%" }} className="table mb-2">
                    <tbody>
                        <tr>
                            <td style={{ width: 250 }}>Aðfangadagur, 24. desember</td>
                            <td>08:00 - 16:00</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Jóladagur, 25. desember</td>
                            <td>Lokað</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Annar í jólum, 26. desember</td>
                            <td>09:00 - 17:00</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Gamlársdagur, 31. desember</td>
                            <td>08:00 - 16:00</td>
                        </tr>
                        <tr>
                            <td style={{ width: 250 }}>Nýársdagur, 1. janúar</td>
                            <td>Lokað</td>
                        </tr>
                    </tbody>
                </table>
            </InfoSection> */}
            <InfoSection title="Símtöl í 1819" titleSize={4}>
                <p>
                    Mínútulangt símtal í 1819 kostar samkvæmt verðskrá hér að neðan. Fjarskiptafélög
                    leggja mismunandi gjald á verðskrá 1819 samkvæmt eigin verðskrá.
                </p>
                <table style={{ width: "100%" }} className="table mb-2">
                    <tbody>
                        <tr>
                            <td style={{ width: 250 }}>Upphafsverð</td>
                            <td>434 kr.</td>
                        </tr>
                        <tr>
                            <td>Mínútuverð</td>
                            <td>387 kr.</td>
                        </tr>
                    </tbody>
                </table>
            </InfoSection>
            <InfoSection title="Þjónusta 1819" titleSize={4}>
                <table style={{ width: "100%" }} className="table mb-2">
                    <tbody>
                        <tr>
                            <td style={{ width: 250 }}>Áframtenging og SMS</td>
                            <td>Innifalin í símtali</td>
                        </tr>
                        <tr>
                            <td>Tímamæling</td>
                            <td>60/60</td>
                        </tr>
                    </tbody>
                </table>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
